export default {
  homeUi: {
    seo: {
      title: 'AQUAMARINA TOURS | Excursions en goélette, bateau et jeep à Paraty',
      description: 'AQUAMARINA TOURS - Expériences océaniques uniques à Paraty, RJ. Excursions en goélette, bateaux privés, jeep tour sur la Costa Verde, snorkeling et plongée.',
    },
    hero: {
      subtitleTail: 'vous attendent dans les eaux cristallines de Paraty.',
      showcaseBadge: 'À LA UNE AQUAMARINA',
      showcaseCta: 'Voir l’excursion',
      showcaseAria: 'Voir les détails de {{title}}',
      experiencesAria: 'Expériences disponibles',
      experiences: {
        schooner: 'GOÉLETTE',
        boat: 'BATEAU',
        jeep: 'JEEP',
        diving: 'PLONGÉE',
      },
      featuredAria: 'Excursions à la une',
      route: 'PARATY · COSTA VERDE · BRÉSIL',
      scrollCue: 'FAITES DÉFILER POUR EXPLORER',
    },
    why: {
      safety: 'Équipage formé, gilets de sauvetage pour tous les passagers et embarcations régulièrement inspectées par la Marine brésilienne.',
      guides: 'Nos guides connaissent chaque recoin de Paraty — des plages cachées aux histoires derrière chaque île.',
      boats: 'Goélettes confortables, bateaux modernes et jeeps 4x4 révisés. Équipement de snorkeling et de plongée haut de gamme.',
      price: 'Pas de frais cachés. Le prix affiché sur le site est le prix final. Paiement par carte en 3 fois maximum.',
    },
    bolivia: {
      bgAlt: 'Salar de Uyuni, Bolivie',
      slideAlt: 'Expédition Salar de Uyuni',
      included: {
        accommodation: 'Hébergement 2 Nuits',
        meals: 'Tous les Repas',
        transport: 'Transport 4x4',
        guide: 'Guide Expérimenté',
        sunset: 'Coucher de Soleil sur le Salar',
        flamingos: 'Flamants & Lagunes',
      },
    },
    trust: {
      cadasturAlt: 'Cadastur - Registre national brésilien des prestataires de services touristiques',
      tripadvisorAlt: 'Note de 5 étoiles sur Tripadvisor',
      tripadvisorText: 'Certificat d’Excellence',
      googleAlt: 'Note de 4.9 sur Google',
      googleText: '4.9/5 Avis Google',
      supportName: 'Service client',
      supportAlt: 'Service client via WhatsApp',
      supportText: 'Assistance 24 h/24',
    },
    contact: {
      mapTitle: 'Carte de Paraty',
    },
    testimonials: {
      ratingAria: '{{rating}} sur 5',
    },
    footer: {
      links: 'Liens',
      privacy: 'Confidentialité',
      cookies: 'Cookies',
      terms: 'Conditions',
      reservations: 'Réservations',
      cancellations: 'Annulations',
    },
    cart: {
      floatingAria: 'Panier d’excursions',
    },
    countdown: {
      aria: 'Compte à rebours : {{time}}',
    },
    marquee: {
      aria: 'Nos expériences',
    },
  },
};
